import { render, staticRenderFns } from "./Sketch.vue?vue&type=template&id=7bae9f06&scoped=true"
import script from "./Sketch.vue?vue&type=script&lang=js"
export * from "./Sketch.vue?vue&type=script&lang=js"
import style0 from "./Sketch.vue?vue&type=style&index=0&id=7bae9f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae9f06",
  null
  
)

export default component.exports